import { action } from "typesafe-actions";
import { CLEAR_ERRORS, LOADING_UI, SET_ERRORS } from "../../../constants/types";
import { IError } from "../../../redux/actions/errorHandlingAction";

export const setErrors = (error: IError) => action(SET_ERRORS, error);

export const clearErrors = () => action(CLEAR_ERRORS);

export const loadingUi = () => action(LOADING_UI);
